// 来自 http://stdl.qq.com/stdl/tq_center/activity/common/header_footer_v2.js
// 暂时使用，后面需要替换掉这个旧的

(function($) {
  var userInfo = {};
  var isQB = isQB = isQQBrowser();

  function getUserInfo(cb) {
    zUtil.ensureLogin(function() {
      $.ajax({
        url: 'http://cgi.vip.qq.com/contact/getusercontact',
        type: "get",
        dataType: "jsonp",
        data: {
          g_tk: qq.security.getCSRFToken()
        },
        jsonp: "callback",
        success: function(json) {
          if (json.ret === 0) {
            userInfo = {
              name: json.data.NAME,
              phone: json.data.PHONE,
              email: json.data.EMAIL,
              address: json.data.POST_ADDR
            };
            cb ? cb(userInfo) : null;
          } else if (json.ret === -7) {
            qq.login.open();
          } else {}
        }
      });
    });
  };

  function setUserInfo(obj, cb) {
    for (var i in obj) {
      obj[i] = obj[i].trim();
    }
    if (obj.name.length == 0) {
      alert('濮撳悕涓嶈兘涓虹┖锛�');
      return;
    } else if (obj.name.length < 2 || !(/^[a-zA-Z\u4e00-\u9fa5]{0,}$/).test(obj.name)) {
      alert('濮撳悕涓嶅悎娉曪紝璇烽噸鏂拌緭鍏ワ紒');
      return;
    }
    if (obj.phone.length == 0) {
      alert('鎵嬫満鍙蜂笉鑳戒负绌猴紒');
      return;
    } else if (obj.phone != userInfo.phone) {
      if (isNaN(obj.phone) || obj.phone.length != 11) {
        alert('璇疯緭鍏ユ湁鏁堢殑鎵嬫満鍙凤紒');
        return;
      }
    }
    if (obj.email.length == 0) {
      alert('鐢靛瓙閭涓嶈兘涓虹┖锛�');
      return;
    } else if (!(/^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/).test(obj.email)) {
      alert('璇疯緭鍏ユ湁鏁堢殑鐢靛瓙閭锛�');
      return;
    }
    if (obj.address.length == 0) {
      alert('閭瘎鍦板潃涓嶈兘涓虹┖锛�');
      return;
    } else if (!(/^[a-zA-Z0-9\u4e00-\u9fa5]{0,}$/).test(obj.address)) {
      alert('闈炴硶鐨勬眽瀛楀拰鑻辨枃瀛楃锛岃閲嶆柊杈撳叆锛�');
      return;
    }
    var _url = 'http://cgi.vip.qq.com/contact/setusercontact?name=' + obj.name + '&phone=' + obj.phone + '&email=' + obj.email + '&post_address=' + obj.address + '&noChange_phone=';
    if (obj.phone == userInfo.phone) {
      _url += "1";
    } else {
      _url += "0";
    }
    var temp = 0;
    for (var k in obj) {
      if (obj[k] == userInfo[k]) {
        temp++;
      }
    }
    if (temp == 4) {
      cb ? cb() : null;
      return;
    }
    zUtil.ensureLogin(function() {
      $.ajax({
        url: _url,
        type: "get",
        dataType: "jsonp",
        data: {
          g_tk: qq.security.getCSRFToken()
        },
        jsonp: "callback",
        success: function(json) {
          if (json.ret == 0) {
            cb ? cb() : null;
          } else if (json.ret == -7) {
            qq.login.open();
          } else {}
        }
      });
    });
  }

  function initUserInfo(phone) {
    $('body').on('focus', '#' + phone, function() {
      if ($(this).val() == userInfo.phone) {
        $(this).val('');
      }
    });
    $('body').on('blur', '#' + phone, function() {
      if ($(this).val() == '') {
        $(this).val(userInfo.phone);
      }
    });
  }

  function submitUserInfo(name, phone, email, address, cb) {
    userContact = {
      name: $('#' + name).val(),
      phone: $('#' + phone).val(),
      email: $('#' + email).val(),
      address: $('#' + address).val()
    };
    setUserInfo(userContact, function() {
      cb ? cb() : '';
    })
  }

  function report(hottagValue) {
    window.setTimeout(function() {
      try {
        pgvSendClick({
          hottag: hottagValue
        });
      } catch (e) {}
    }, 100);
  }

  function dataReport(a, b, c, d, e, f, g, h, i) {
    window.setTimeout(function() {
      try {
        window.external.dataReport(a, b, c, d, e, f, g, h, i);
      } catch (e) {
        console.log(e)
      }
    }, 100);
  }
  window.setTimeout(function() {
    if (typeof(pgvMain) == 'function') {
      pgvMain("pathtrace", {
        pathStart: true,
        tagParamName: "ADTAG",
        useRefUrl: true,
        override: true,
        careSameDomainRef: false
      });
    }
  }, 1000)

  function getQBVersion() {
    var version = 0;
    try {
      try {
        version = window.external.getVersion() || 1;
      } catch (e) {
        version = window.external.getbrowserversion() || 1;
      }
    } catch (e) {
      version = /QQBrowser/.test(navigator.userAgent) || "100.0.0.0";
    }
    return version;
  }

  function isQQBrowser() {
    var version = getQBVersion();
    var result = (version != "100.0.0.0") && (version != 0);
    isQQBrowser = function() {
      return result;
    };
    return result;
  }

  window.api = {
    setUserInfo: setUserInfo,
    getUserInfo: getUserInfo,
    initUserInfo: initUserInfo,
    submitUserInfo: submitUserInfo,
    report: report,
    dataReport: dataReport,
    getQBVersion: getQBVersion,
    isQQBrowser: isQQBrowser,
    isQB: isQB
  };

})(jQuery)


// WEBPACK FOOTER //
// ./common/old.api.js